<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M5.0017 5L19 19M18.9983 5L5 19"
            stroke="currentColor"
            stroke-width="3"
        />
    </svg>
</template>
